import { uniq } from 'ramda';
import { Union } from 'ts-toolbelt';

import { DemandDetailContentProps } from './components/DemandDetailContent/DemandDetailContent';

export const getPreferredSupplierId = <T extends Union.Nullable<{ preferredSupplierId?: string }>>(
  lineItems?: Union.Nullable<T[]>,
) => {
  const hasUniquePreferredSupplierId =
    lineItems &&
    uniq(lineItems?.map((item) => item?.preferredSupplierId).filter((item) => item !== null || item !== undefined))
      .length === 1;

  return hasUniquePreferredSupplierId ? lineItems?.[0]?.preferredSupplierId : '';
};

export const getAllCommodityGroupIds = (data: DemandDetailContentProps['data']): string[] => {
  if (!data?.demandRequest) {
    return [];
  }

  const itemsCommodityGroups =
    data.demandRequest.lineItems?.reduce((accum, curr) => {
      if (curr && curr.commodityGroupId) {
        accum.push(curr.commodityGroupId);
      }
      return accum;
    }, [] as string[]) ?? [];

  if (data.demandRequest.commodityGroupId) {
    itemsCommodityGroups.push(data.demandRequest.commodityGroupId);
  }

  return itemsCommodityGroups;
};
